import styled from "styled-components";

const Button = styled.button`
  background: ${(props) => props.background || "transparent"};
  border-radius: ${(props) => props.borderRadius || "9px"};
  border: ${(props) => props.border || "10px"};
  color: ${(props) => props.color || "white"};
  margin: ${(props) => props.margin || ".2rem"};
  padding: ${(props) => props.padding || ".5rem"};
  width:${(props) => props.width || "120px"};
  &:focus {
    outline: none;
  }
`;
export default Button;
